import * as TYPES from '../types';

export const getAllEventAction = () => {
    return {
        type: TYPES.GET_ALL_EVENTS,
    };
};

export const getAllEventSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_EVENTS_SUCCESS,
        payload: payload
    };
};